// apps/admin-ui/src/components/widgets/AuditReports.tsx
// Audit reports listing widget
// ALL RIGHTS RESERVED

import { Link } from 'react-router-dom';
import '../styles/widgets.css';

export interface AuditReportsProps {
  data?: {
    reports: {
      id: string;
      title: string;
      type: 'monthly' | 'quarterly' | 'annual' | 'security';
      date: string;
      auditor: string;
      status: 'final' | 'draft' | 'pending';
    }[];
  };
}

export function AuditReports({ data }: AuditReportsProps) {
  // Mock data for development
  const auditData = data || {
    reports: [
      { id: 'RPT-2026-01', title: 'January 2026 Reserve Attestation', type: 'monthly' as const, date: '2026-01-31', auditor: 'Grant Thornton LLP', status: 'final' as const },
      { id: 'RPT-2025-Q4', title: 'Q4 2025 Smart Contract Audit', type: 'quarterly' as const, date: '2026-01-15', auditor: 'CertiK', status: 'final' as const },
      { id: 'RPT-2025-SEC', title: '2025 Annual Security Assessment', type: 'security' as const, date: '2025-12-20', auditor: 'Mandiant', status: 'final' as const },
      { id: 'RPT-2026-02', title: 'February 2026 Reserve Attestation', type: 'monthly' as const, date: '2026-02-28', auditor: 'Grant Thornton LLP', status: 'pending' as const },
    ],
  };

  const typeLabels = {
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    annual: 'Annual',
    security: 'Security',
  };

  const typeColors = {
    monthly: 'var(--color-info)',
    quarterly: 'var(--color-primary)',
    annual: 'var(--color-success)',
    security: 'var(--color-warning)',
  };

  const statusLabels = {
    final: '✓ Final',
    draft: '◐ Draft',
    pending: '○ Pending',
  };

  const formatDate = (dateStr: string) =>
    new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

  return (
    <div className="widget-audit-reports">
      <table className="audit-reports-table">
        <thead>
          <tr>
            <th>Report</th>
            <th>Type</th>
            <th>Date</th>
            <th>Auditor</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {auditData.reports.map((report) => (
            <tr key={report.id}>
              <td>
                <Link to={`/admin/audit/reports/${report.id}`} className="report-link">
                  {report.title}
                </Link>
              </td>
              <td>
                <span
                  className="report-type-badge"
                  style={{ backgroundColor: typeColors[report.type] }}
                >
                  {typeLabels[report.type]}
                </span>
              </td>
              <td className="report-date">{formatDate(report.date)}</td>
              <td className="report-auditor">{report.auditor}</td>
              <td className={`report-status status-${report.status}`}>
                {statusLabels[report.status]}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AuditReports;
